export enum CollaboTypes {
  CREATE_COLLABO_CALL = 'CREATE_COLLABO_CALL',
  CREATE_COLLABO_SUCCESS = 'CREATE_COLLABO_SUCCESS',

  COLLABO_FORM_DATA = 'COLLABO_FORM_DATA',
  CLEAR_COLLABO_DATA = 'CLEAR_COLLABO_DATA',
  UPDATE_CREATE_COLLABO_FORM_CALL = 'UPDATE_CREATE_COLLABO_FORM_CALL',
  CLEAR_CREATE_COLLABO_FORM_CALL = 'CLEAR_CREATE_COLLABO_FORM_CALL',

  UPDATE_COLLABO_PARTICIPANTS = 'UPDATE_COLLABO_PARTICIPANTS',
  UPDATE_COLLABO_PARTICIPANTS_CALL = 'UPDATE_COLLABO_PARTICIPANTS_CALL',

  UPDATE_ACCEPT_INVITE_PAYLOAD = 'UPDATE_ACCEPT_INVITE_PAYLOAD',
  UPDATE_ACCEPT_INVITE_PAYLOAD_CALL = 'UPDATE_ACCEPT_INVITE_PAYLOAD_CALL',
  CLEAR_ACCEPT_INVITE_PAYLOAD = 'CLEAR_ACCEPT_INVITE_PAYLOAD',
  CLEAR_ACCEPT_INVITE_PAYLOAD_CALL = 'CLEAR_ACCEPT_INVITE_PAYLOAD_CALL',

  DELETE_COLLABO_CALL = 'DELETE_COLLABO_CALL',
  DELETE_COLLABO_SUCCESS = 'DELETE_COLLABO_SUCCESS',

  GET_ALL_COLLABO_CALL = 'GET_ALL_COLLABO_CALL',
  GET_ALL_COLLABO_SUCCESS = 'GET_ALL_COLLABO_SUCCESS',

  GET_COLLABO_ACTIVITIES_CALL = 'GET_COLLABO_ACTIVITIES_CALL',
  GET_COLLABO_ACTIVITIES_SUCCESS = 'GET_COLLABO_ACTIVITIES_SUCCESS',

  GET_COLLABO_LEADERBOARD_CALL = 'GET_COLLABO_LEADERBOARD_CALL',
  GET_COLLABO_LEADERBOARD_SUCCESS = 'GET_COLLABO_LEADERBOARD_SUCCESS',

  SEARCH_INVITEE_CALL = 'SEARCH_INVITEE_CALL',
  SEARCH_INVITEE_SUCCESS = 'SEARCH_INVITEE_SUCCESS',

  GET_COLLABO_INVITES_CALL = 'GET_COLLABO_INVITES_CALL',
  GET_COLLABO_INVITES_SUCCESS = 'GET_COLLABO_INVITES_SUCCESS',

  ACCEPT_COLLABO_INVITE_CALL = 'ACCEPT_COLLABO_INVITE_CALL',
  ACCEPT_COLLABO_INVITE_SUCCESS = 'ACCEPT_COLLABO_INVITE_SUCCESS',

  REJECT_COLLABO_INVITE_CALL = 'REJECT_COLLABO_INVITE_CALL',
  REJECT_COLLABO_INVITE_SUCCESS = 'REJECT_COLLABO_INVITE_SUCCESS',

  SEND_COLLABO_INVITE_CALL = 'SEND_COLLABO_INVITE_CALL',
  SEND_COLLABO_INVITE_SUCCESS = 'SEND_COLLABO_INVITE_SUCCESS',
}

export interface CollaboState {
  all: []
  searchUser: []
  activities: []
  leaderboard: []
  invites: []
  createCollaboForm: CreateCollaboPayload
  inviteForm: CollaboInvitePayload
}

export interface CreateCollaboPayload {
  group_name: string
  description: string
  target: string
  start_date: string
  end_date: string
  image: string
  participants: Array<string>
}

export interface CollaboInvitePayload {
  saving_type: string
  main_card: string
  saving_frequency: string
  start_date: string
  amount_to_save: string
  device?: string
}
